import styles from './Section.module.css';
import React from 'react';
import { RedButtonLink } from '../Buttons/Buttons';



export const Section1 = (props) => {
	const value = props.details.heading + ' ' + props.details.buttonLabel + '|' + props.details.buttonLink;
	return (
		<div className={styles.layout}>
			<div className={styles.left}>
				<div className={styles.text}>
					<span className={styles.title}><b>{props.details.heading}</b></span><br/><br/>
					<p >{props.details.description }</p>
				</div>
				<div className={styles.button_row}>				
					<RedButtonLink
						data-tealium-category="link"
						data-tealium-action="click navigation"
						data-tealium-type="action"
						data-tealium-value={value}
						to={props.details.buttonLink}
						label={props.details.buttonLabel}
					>
					</RedButtonLink>
				</div>
			</div>
			<div className={styles.right}>
				<div style={{backgroundImage:`url(${props.details.cropImage})` }} role="img" aria-label={props.details.cropImageAlt} className={styles.picture} />
			</div>
			<div className={styles.mobile_button_row}>				
					<RedButtonLink
						data-tealium-category="link"
						data-tealium-action="click navigation"
						data-tealium-type="action"
						data-tealium-value={value}
						to={props.details.buttonLink}
						label={props.details.buttonLabel}
					>
					</RedButtonLink>
				</div>
		</div>
	);
}

export const Section2 = (props) => {
	const value = props.details.heading + ' ' + props.details.buttonLabel + '|' + props.details.buttonLink;
	var tcStyles;
	var buttonStyles;

	if (props.details.showTC === "true") {
		tcStyles = {
			display: "inline-block",
			visibility: "visible",
		};
		buttonStyles = {
			display: "none",
			visibility: "hidden",
		};
	}
	else {
		tcStyles = {
			display: "none",
			visibility: "hidden",
		};
		buttonStyles = {};
		
	}
	return (
		<div className={styles.section}> {/*grid*/}

			<div className={styles.cropImage} style={{ backgroundImage: `url(${props.details.cropImage})` }} role="img" aria-label={props.details.cropImageAlt}> {/*row 1*/}
			</div>

			<div className={styles.boxHeading}>{props.details.heading}</div> {/*row 2*/}

			<div className={styles.preview}> {/*row 3*/}
				<div className={styles.description} dangerouslySetInnerHTML={{ __html: props.details.description }}></div>
				<div>
					<RedButtonLink
						data-tealium-category="link"
						data-tealium-action="click navigation"
						data-tealium-type="action"
						data-tealium-value={value}
						to={props.details.buttonLink}
						label={props.details.buttonLabel}
						style={buttonStyles}
					>
					</RedButtonLink>
					<a
						data-tealium-category="link"
						data-tealium-action="click pdf_link"
						data-tealium-type="download"
						data-tealium-value="Terms and Conditions|/preseedherbicide/assets/Pre-Seed_FeelTheBurn_TCs.pdf"
						href="/preseedherbicide/assets/Pre-Seed_FeelTheBurn_TCs.pdf"
						target="_blank" rel="noopener noreferrer"
						style={tcStyles}
						className={[styles.button,styles.red_button].join(' ')}
					>
						Terms and Conditions
					</a>
				</div>
			</div>
		</div>
	)
}

export const Section3 = (props) => {
	const value = props.details.heading + ' ' + props.details.buttonLabel + '|' + props.details.buttonLink;

	return (

		<div className={styles.section}> {/*grid*/}

			<div className={styles.cropImage} style={{ backgroundImage: `url(${props.details.cropImage})` }} role="img" aria-label={props.details.cropImageAlt}> {/*row 1*/}
			</div>


			<img className={styles.productLogo} alt={`${props.details.heading} logo`} src={props.details.productLogo}></img> {/*row 2*/}

			<div className={styles.preview}> {/*row 3*/}
				<div className={styles.description} dangerouslySetInnerHTML={{ __html: props.details.description }}></div>
				<RedButtonLink
					to={props.details.buttonLink}
					data-tealium-category="link"
					data-tealium-action="click navigation"
					data-tealium-type="action"
					data-tealium-value={value}
					label={props.details.buttonLabel}
				>
				</RedButtonLink>
			</div>
			<div className={styles.iconFlex}>
				{props.details.productIcons.map((elem, index) => ((
					<img className={styles.productIcon} key={index} alt={`${elem[1]} icon`} title={`${elem[1]}`} src={elem[0]}></img>
				)))}
			</div>
		</div>


	)
}

